import { useEffect, useState } from "react";

export interface DatePickerProps {
  feedbackValid?: string;
  feedbackInvalid?: string;
  validator?: (val: Date) => {
    valid?: boolean;
    feedback?: string;
    noValidate?: boolean;
  } | void;
  validated?: boolean;
  onFocus?: () => void;
}

const useDatePicker = (defaultValue: Date, p?: DatePickerProps) => {
  const [date, setDate] = useState<Date>(defaultValue);
  const [valid, setValid] = useState(true);
  const [invalid, setInvalid] = useState(false);
  const [feedbackValid, setFeedbackValid] = useState(p?.feedbackValid ?? "");
  const [feedbackInvalid, setFeedbackInvalid] = useState(
    p?.feedbackInvalid ?? "",
  );
  const validated = p?.validated ?? false;

  useEffect(() => {
    if (p?.validator) {
      const res = p.validator(date);

      if (res) {
        if (res.noValidate !== undefined) {
          if (res.noValidate) {
            setValid(false);
            setInvalid(false);
            return;
          }
        }
        setValid(res?.valid ?? false);
        setInvalid(res?.valid === false);
        setFeedbackValid(res.feedback ?? "");
      }
    }
  }, [p, date, validated]);

  const peek = () => {
    return {
      date,
      valid: validated ? valid : false,
      invalid: validated ? invalid : false,
      feedbackValid,
      feedbackInvalid,
    };
  };

  const onFocus = () => {
    if (p?.onFocus) {
      p.onFocus();
    }
  };

  return [
    {
      date,
      valid: validated ? valid : false,
      invalid: validated ? invalid : false,
      feedbackValid,
      feedbackInvalid,
    },
    {
      setDate,
      peek,
      onFocus,
      setValid,
      setInvalid,
      setFeedbackValid,
      setFeedbackInvalid,
    },
  ] as const;
};

export default useDatePicker;
